import FeaturedPostGrid from './FeaturedPostGrid';

export default FeaturedPostGrid;
export type { FeaturedPostGridPropTypes } from './FeaturedPostGrid';
